import { Box, VStack, Text } from '@bpba/ui-components';
import { Outlet } from 'react-router-dom';
import { useShrink } from '../useShrink';
import { StyledBox } from '../StyledBox';
import { APP_TITLE } from '../../../constants/data';
import { useScrolltoContent } from '../useScrolltoContent';

export const LayoutLoginSingUp = () => {
  useScrolltoContent();
  const { shrink } = useShrink();

  return (
    <StyledBox
      maxWidth={['100%', 'fit-content']}
      minHeight={'600px'}
      margin={'auto'}
      marginTop={shrink ? ['165px', '200px'] : ['0px', null, null, null, '48px']}
      marginBottom={['24px', null, null, null, '48px']}
    >
      <VStack backgroundColor={'secondary.2'}>
        <Box background={'linear-gradient(270deg,#26b4bd,#3daa35)'} color={'white'} justifyContent={'center'} py={'16px'} mb={'8px'}>
          <Text fontWeight={'500'} fontSize={'16px'}>
            {APP_TITLE}
          </Text>
        </Box>
        <VStack padding={['24px 16px', '24px']} margin={'0px auto'}>
          <VStack width={['100%', '450px']}>
            <Outlet />
          </VStack>
        </VStack>
      </VStack>
    </StyledBox>
  );
};
